<twc-popup caption="{{'PROJECTS.RELATED_SITES' | translate}}" type="primary" width="m"
    class="related-projects-container">
    <twc-popup-content>
        <div class="twc-mb-3 twc-mt-2" [innerHTML]="'PROJECTS.RELATED_DESCRIPTION' | translate : {project:object.name}">
        </div>
        <div *ngIf="!isLoading; else showLoading">
            <twc-list class="related-site-list">
                <twc-list-item *ngFor="let site of siteList">
                    <div class="twc-list-item-col-2 word-break">{{site.name}}</div>
                    <div class="twc-list-item-col-3 icons-container">
                        <twc-icon shape="open-in-browser" [size]="24" class="twc-mr-2 cursor-pointer"
                            color="twc-topcon-blue" (click)="openSelectedSite(site.id)"
                            twcTooltip="{{'PROJECTS.OPEN_SITE' | translate}}"></twc-icon>
                        <twc-icon shape="delete" class="remove-icon" color="twc-topcon-blue"
                            twcTooltip="{{'PROJECTS.REMOVE_FROM_SITE' | translate}}"
                            (click)="dettachProjectFromSelectedSite(site.id, object.id)"></twc-icon>
                    </div>
                </twc-list-item>
            </twc-list>
        </div>
    </twc-popup-content>
</twc-popup>
<ng-template #showLoading>
    <twc-loader class="loader-position" size="tiny"></twc-loader>
</ng-template>